import { useQuery } from '@tanstack/react-query';
import { countriesApi } from '../api/countries.api';
import type { CountryPaginationParams } from '../types/countries.types';
import { countryKeys } from './queryKeys';

export const useCountries = (pagination: CountryPaginationParams = {}) => {
  const { page = 1, pageSize = 10, searchTerm, isActive, level } = pagination;

  const { data, isLoading } = useQuery({
    queryKey: countryKeys.list(page, pageSize, isActive, searchTerm, level),
    queryFn: () =>
      countriesApi.getCountries({
        page,
        pageSize,
        searchTerm,
        isActive,
        level,
      }),
  });

  return {
    countries: data?.data?.items ?? [],
    pagination: {
      page: data?.data?.page ?? 1,
      pageSize: data?.data?.pageSize ?? 10,
      totalCount: data?.data?.totalCount ?? 0,
      totalPages: data?.data?.totalPages ?? 0,
      hasPreviousPage: data?.data?.hasPreviousPage ?? false,
      hasNextPage: data?.data?.hasNextPage ?? false,
      firstItemOnPage: data?.data?.firstItemOnPage,
      lastItemOnPage: data?.data?.lastItemOnPage,
    },
    isLoading,
  };
};
